// Mock data for Women's Club of Lincoln County website

export const siteConfig = {
  name: "Women's Club of Lincoln County",
  shortName: "WCLC",
  tagline: "Where Women Lead, Communities Rise.",
  email: "Info@wclcnc.com",
  phone: "(828) 838-8688",
  socialLinks: {
    facebook: "https://facebook.com/wclc",
    instagram: "https://instagram.com/wclc",
    linkedin: "https://linkedin.com/company/wclc",
  },
};

export const heroContent = {
  title: "Where Women Lead, Communities Rise.",
  subtitle: "The Women's Club of Lincoln County is a nonpartisan organization dedicated to cultivating community advancement through women's leadership while empowering every woman to grow into her truest self.",
  ctaText: "Join Our Movement",
  secondaryCtaText: "Learn More",
  backgroundImage: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/01c4d116d0de46286391f42e74d11a560ff4e040736acac214dd9724fdec7d87.jpeg",
};

export const missionContent = {
  mission: "To cultivate community advancement through women's leadership while empowering every woman to grow into her truest self.",
  vision: "A Lincoln County where every woman has the opportunity, resources, and support to lead authentically and contribute meaningfully to our community's growth and wellbeing.",
  values: [
    { title: "Empowerment", description: "Supporting every woman's journey to her truest self" },
    { title: "Leadership", description: "Cultivating confident, compassionate community leaders" },
    { title: "Inclusion", description: "Welcoming women of all backgrounds, ages, and experiences" },
    { title: "Service", description: "Advancing our community through meaningful action" },
    { title: "Integrity", description: "Operating with transparency and nonpartisan commitment" },
  ],
};

export const programs = [
  {
    id: "arts-culture",
    title: "Arts & Culture",
    description: "Celebrating creativity across Lincoln County through arts appreciation, cultural enrichment events, and support for local artists and makers.",
    icon: "Palette",
    goals: [
      "Promote local arts and artists",
      "Host cultural enrichment events",
      "Support arts education for women and youth",
    ],
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/b9b87b0d9e770691a0695868ba32bbddf1f709f9b38e66cfb7c39498ee3c1d97.jpeg",
  },
  {
    id: "civic-engagement",
    title: "Civic Engagement & Outreach",
    description: "Strengthening our community through civic participation, volunteer outreach, and service to neighbors in need.",
    icon: "Megaphone",
    goals: [
      "Organize community service projects",
      "Support local civic initiatives",
      "Connect members with outreach opportunities",
    ],
    image: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg",
  },
  {
    id: "education-libraries",
    title: "Education & Libraries",
    description: "Championing education, literacy, and libraries for women, children, and families across Lincoln County.",
    icon: "BookOpen",
    goals: [
      "Support literacy programs and local libraries",
      "Fund educational scholarships for women",
      "Host learning workshops and book drives",
    ],
    image: "https://images.pexels.com/photos/8127326/pexels-photo-8127326.jpeg",
  },
  {
    id: "environment",
    title: "Environment",
    description: "Preserving and protecting our natural surroundings through conservation, beautification, and environmental education.",
    icon: "Leaf",
    goals: [
      "Lead community beautification projects",
      "Promote conservation and recycling",
      "Partner on outdoor and environmental education",
    ],
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/f46f1c3af1de4160b8a153434885d2d65a1fa4469a75cc1bc6fb92a328885ef0.jpeg",
  },
  {
    id: "health-wellness",
    title: "Health & Wellness",
    description: "Promoting the physical, mental, and emotional wellbeing of women and families in our community.",
    icon: "HeartPulse",
    goals: [
      "Host wellness events and workshops",
      "Support mental health awareness",
      "Promote healthy living resources",
    ],
    image: "https://images.pexels.com/photos/7551644/pexels-photo-7551644.jpeg",
  },
];

export const events = [
  {
    id: "evt-meeting-2026-08",
    title: "Monthly Membership Meeting",
    date: "2026-08-04",
    time: "6:00 PM",
    location: "Location TBD",
    description: "Join us for our monthly membership meeting as we build the Women's Club of Lincoln County. All women interested in becoming founding members are welcome.",
    category: "Meeting",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/1e0787f763ab25cea7fc5a1dfb54417e346ba8b4dd32551a02f3dbd5cf02bdd2.jpeg",
    spotsAvailable: 50,
  },
  {
    id: "evt-meeting-2026-09",
    title: "Monthly Membership Meeting",
    date: "2026-09-01",
    time: "6:00 PM",
    location: "Location TBD",
    description: "Join us for our monthly membership meeting as we build the Women's Club of Lincoln County. All women interested in becoming founding members are welcome.",
    category: "Meeting",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/b36ab3a3a32104cf74d81ead3aa847386154c49f916583929126e7125aa42d81.jpeg",
    spotsAvailable: 50,
  },
  {
    id: "evt-meeting-2026-10",
    title: "Monthly Membership Meeting",
    date: "2026-10-06",
    time: "6:00 PM",
    location: "Location TBD",
    description: "Join us for our monthly membership meeting as we build the Women's Club of Lincoln County. All women interested in becoming founding members are welcome.",
    category: "Meeting",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/8850bd7ba1c1727343c26d34cac1f774e7c81cb07f8361b0d503b236ca6ee375.jpeg",
    spotsAvailable: 50,
  },
  {
    id: "evt-meeting-2026-11",
    title: "Monthly Membership Meeting",
    date: "2026-11-03",
    time: "6:00 PM",
    location: "Location TBD",
    description: "Join us for our monthly membership meeting as we build the Women's Club of Lincoln County. All women interested in becoming founding members are welcome.",
    category: "Meeting",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/bf2d2a16a417bc286de9f214ffec3fca861e0b3e5758a08f8d95f082a1e3e666.jpeg",
    spotsAvailable: 50,
  },
  {
    id: "evt-meeting-2026-12",
    title: "Monthly Membership Meeting",
    date: "2026-12-01",
    time: "6:00 PM",
    location: "Location TBD",
    description: "Join us for our monthly membership meeting as we build the Women's Club of Lincoln County. All women interested in becoming founding members are welcome.",
    category: "Meeting",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/a59583175b94a16288a05ae2a32f31883fe99fcc909defb0985c777269bef982.jpeg",
    spotsAvailable: 50,
  },
];

export const boardMembers = [
  {
    id: "board-founder",
    name: 'Marjorie "MJ" Mauney',
    title: "Founding Organizer & Community Development Lead",
    bio: "MJ is leading the founding of the Women's Club of Lincoln County — organizing our first recruitment cycle, building community partnerships, and laying the groundwork for our programs.",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fc3829d4-353f-4fc4-b817-cd1ab3ff1600/artifacts/j5lbbk2d_Headshot%203.2.jpeg",
  },
  {
    id: "board-chair",
    name: "Open Position",
    title: "Board Chair",
    bio: "This founding board position is open. We're recruiting women ready to help build the Women's Club of Lincoln County from the ground up.",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
  {
    id: "board-vice-chair",
    name: "Open Position",
    title: "Vice Chair",
    bio: "This founding board position is open. We're recruiting women ready to help build the Women's Club of Lincoln County from the ground up.",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
  {
    id: "board-secretary",
    name: "Open Position",
    title: "Secretary",
    bio: "This founding board position is open. We're recruiting women ready to help build the Women's Club of Lincoln County from the ground up.",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
  {
    id: "board-treasurer",
    name: "Open Position",
    title: "Treasurer",
    bio: "This founding board position is open. We're recruiting women ready to help build the Women's Club of Lincoln County from the ground up.",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
  {
    id: "board-programs",
    name: "Open Position",
    title: "Programs Director",
    bio: "This founding board position is open. We're recruiting women ready to help build the Women's Club of Lincoln County from the ground up.",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
  {
    id: "board-membership",
    name: "Open Position",
    title: "Membership Chair",
    bio: "This founding board position is open. We're recruiting women ready to help build the Women's Club of Lincoln County from the ground up.",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
];

export const membershipLevels = [
  {
    id: "junior",
    name: "Junior Member",
    price: 20,
    period: "year",
    benefits: [
      "For young women and students",
      "Quarterly newsletter",
      "Invitation to public events",
      "Service project participation",
      "Leadership mentoring from members",
    ],
    recommended: false,
  },
  {
    id: "friend",
    name: "Friend",
    price: 35,
    period: "year",
    benefits: [
      "Quarterly newsletter",
      "Invitation to public events",
      "Recognition in annual report",
    ],
    recommended: false,
  },
  {
    id: "member",
    name: "Member",
    price: 75,
    period: "year",
    benefits: [
      "All Friend benefits",
      "Voting rights at annual meeting",
      "Access to member-only events",
      "Committee participation",
      "Professional networking opportunities",
    ],
    recommended: true,
  },
  {
    id: "leader",
    name: "Leadership Circle",
    price: 150,
    period: "year",
    benefits: [
      "All Member benefits",
      "Priority registration for programs",
      "Leadership development workshops",
      "Mentorship program access",
      "Recognition at events",
    ],
    recommended: false,
  },
  {
    id: "patron",
    name: "Patron",
    price: 500,
    period: "year",
    benefits: [
      "All Leadership Circle benefits",
      "Annual recognition dinner invitation",
      "Scholarship naming opportunity",
      "Advisory board participation",
      "Personalized impact report",
    ],
    recommended: false,
  },
];

export const testimonials = [
  {
    id: "1",
    quote: "We're building something new in Lincoln County — and our founding members will shape it. This space is reserved for their stories.",
    name: "Your Story Here",
    title: "Founding Member, Fall 2026",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
  {
    id: "2",
    quote: "Our first recruitment cycle begins this fall. Twenty-five founding members will set the tone for everything we become.",
    name: "Founding Class of 2026",
    title: "25 Spots Available",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
  {
    id: "3",
    quote: "Every great club starts with a handful of committed women. We're looking for ours.",
    name: "The Women's Club of Lincoln County",
    title: "Est. 2026",
    image: "https://static.prod-images.emergentagent.com/jobs/fc3829d4-353f-4fc4-b817-cd1ab3ff1600/images/3832b124873ba1f7d20fd6f255d6e0f7d547cc73bb42117aa8a1ab599a0cfa50.jpeg",
  },
];

export const blogPosts = [
  {
    id: "news-founding-recruitment",
    title: "Now Recruiting: 25 Founding Members for Fall 2026",
    excerpt: "The Women's Club of Lincoln County is seeking 25 founding members for our fall recruitment cycle. Help shape a new era of women's leadership in our community.",
    date: "2026-08-01",
    author: 'Marjorie "MJ" Mauney',
    category: "Announcements",
    image: "https://images.pexels.com/photos/2041390/pexels-photo-2041390.jpeg",
  },
  {
    id: "news-monthly-meetings",
    title: "Monthly Membership Meetings Announced",
    excerpt: "Join us each month as we build the club together! Check our Events page for upcoming dates, times, and locations — all interested women are welcome.",
    date: "2026-08-01",
    author: "The Women's Club of Lincoln County",
    category: "Announcements",
    image: "https://images.pexels.com/photos/601170/pexels-photo-601170.jpeg",
  },
];

export const stats = [
  { value: "25", label: "Founding Member Goal" },
  { value: "Fall 2026", label: "Recruitment Cycle" },
  { value: "5", label: "GFWC-Aligned Programs" },
  { value: "Monthly", label: "Membership Meetings" },
];

export const volunteerOpportunities = [
  {
    id: "1",
    title: "Event and Socials Committee",
    commitment: "2–5 hours/month",
    description: "Plan our monthly meetings, socials, and community celebrations — from themes and venues to hospitality and hosting.",
  },
  {
    id: "2",
    title: "Leadership and Mentorship Committee",
    commitment: "2–5 hours/month",
    description: "Design leadership development experiences and build our mentorship program to help every member grow into her truest self.",
  },
  {
    id: "3",
    title: "Community Programs Committee",
    commitment: "2–5 hours/month",
    description: "Shape our five GFWC-aligned focus areas and plan the service projects that will define our impact in Lincoln County.",
  },
];
